class ProductSlider extends HTMLElement {
  mainImages;

  constructor() {
    super();
    this.currentIndex = 0;
    this.isUpdating = false;
    this.touchStartX = 0;
    this.touchStartY = 0;
    this.minSwipeDistance = 50;
  }

  connectedCallback() {
    this.initializeElements();
    this.initializeActiveIndex();
    this.attachEventListeners();
  }

  initializeElements() {
    this.sliderMain = this.querySelector('.slider-main');
    this.sliderNav = this.querySelector('.slider-nav');
    this.navBoxes = this.querySelectorAll('.slider-nav .slider-box');
    this.mainImages = this.querySelectorAll('.slider-main .slider-box__image');
  }

  initializeActiveIndex() {
    this.navBoxes.forEach((box, index) => {
      if (box.classList.contains('active')) {
        this.currentIndex = index;
      }
    });
  }

  updateSlider(index) {
    // Prevent rapid clicks from skipping images
    // if (this.isUpdating) return;
    //
    // this.isUpdating = true;

    // Remove active class from all nav boxes
    this.navBoxes.forEach(box => box.classList.remove('active'));

    // Add active class to current nav box
    if (this.navBoxes[index]) {
      this.navBoxes[index].classList.add('active');

      this.mainImages.forEach(image => {
        image.classList.toggle('active', image.dataset.index == index);
      });

      // Scroll the active thumbnail into view within the slider-nav container
      if (this.sliderNav) {
        const activeBox = this.navBoxes[index];
        const containerRect = this.sliderNav.getBoundingClientRect();
        const boxRect = activeBox.getBoundingClientRect();
        const scrollLeft = this.sliderNav.scrollLeft;
        const boxLeft = boxRect.left - containerRect.left + scrollLeft;
        const boxWidth = boxRect.width;
        const containerWidth = containerRect.width;

        // Calculate the scroll position to center the thumbnail
        const targetScroll = boxLeft - (containerWidth / 2) + (boxWidth / 2);

        this.sliderNav.scrollTo({
          left: targetScroll,
          behavior: 'smooth'
        });
      }
    }

    this.currentIndex = index;

    // // Allow next update after a short delay
    // setTimeout(() => {
    //   this.isUpdating = false;
    // }, 300);
  }

  handlePrevClick() {
    const newIndex = this.currentIndex > 0
      ? this.currentIndex - 1
      : this.navBoxes.length - 1;
    this.updateSlider(newIndex);
  }

  handleNextClick() {
    const newIndex = this.currentIndex < this.navBoxes.length - 1
      ? this.currentIndex + 1
      : 0;
    this.updateSlider(newIndex);
  }

  handleThumbnailClick(index) {
    this.updateSlider(index);
  }

  handleTouchStart(e) {
    const touch = e.touches[0];
    this.touchStartX = touch.clientX;
    this.touchStartY = touch.clientY;
  }

  handleTouchMove(e) {
    // Prevent default scrolling while swiping
    if (Math.abs(e.touches[0].clientX - this.touchStartX) > 10) {
      e.preventDefault();
    }
  }

  handleTouchEnd(e) {
    if (!this.touchStartX || !this.touchStartY) return;

    const touch = e.changedTouches[0];
    const touchEndX = touch.clientX;
    const touchEndY = touch.clientY;

    const deltaX = touchEndX - this.touchStartX;
    const deltaY = touchEndY - this.touchStartY;

    // Check if it's a horizontal swipe (not vertical scroll)
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.minSwipeDistance) {
      if (deltaX > 0) {
        // Swipe right - go to previous image
        this.handlePrevClick();
      } else {
        // Swipe left - go to next image
        this.handleNextClick();
      }
    }

    // Reset touch start values
    this.touchStartX = 0;
    this.touchStartY = 0;
  }

  attachEventListeners() {

    // Handle thumbnail clicks
    this.navBoxes.forEach((box, index) => {
      box.addEventListener('click', () => this.handleThumbnailClick(index));
    });

    // Handle swipe gestures on the main slider
    if (this.sliderMain) {
      this.sliderMain.addEventListener('touchstart', (e) => this.handleTouchStart(e), { passive: false });
      this.sliderMain.addEventListener('touchmove', (e) => this.handleTouchMove(e), { passive: false });
      this.sliderMain.addEventListener('touchend', (e) => this.handleTouchEnd(e), { passive: true });
    }
  }
}

// Register the custom element
customElements.define('product-slider', ProductSlider);

document.addEventListener('DOMContentLoaded', () => {
  const radioButtons = document.querySelectorAll('[name="bundle_id"]');
  radioButtons.forEach(radioButton => {
    radioButton.addEventListener('change', handleRadioButtonChange);
  });

  function handleRadioButtonChange(event) {
    const bundleId = event.target.value;
    const formContainers = document.querySelectorAll('.bundle-form');
    formContainers.forEach(formContainer => {

      console.log(formContainer.dataset.bundleId, bundleId)
      formContainer.classList.toggle('active', formContainer.dataset.bundleId === bundleId);
    });
  }
});